import numeral from 'numeral'
import 'numeral/locales/pt-br'
numeral.locale('pt-br')

export const formatStrToCents = (value: string) => {
  const parsedValue = parseFloat(value)

  return parsedValue * 100
}

export const formatStrToAmount = (value: string) => {
  return parseFloat(value)
}

export const formatToRealStr = (amount: number | string, fromCents = true) => {
  const valueToFormat = fromCents ? numeral(amount).divide(100) : numeral(amount)

  return `R$ ${valueToFormat.format('0,0.00')}`
}

export const formatCurrency = (value?: number | null | string, defaultValue: number | string = 0) => {
  if (!value) {
    return typeof defaultValue === 'string' ? defaultValue : formatToRealStr(defaultValue)
  }

  return formatToRealStr(value)
}

export const formatToNormalizedUrl = (pathname: string): string => {
  if (pathname?.endsWith('/')) {
    return formatToNormalizedUrl(pathname.slice(0, -1))
  } else {
    return pathname
  }
}

export const formatEmail = (email: string) => {
  return email.toLowerCase().replace(/ /g, '')
}

export const getPartnerFromURLQuery = (query: string) => {
  const urlParams = new URLSearchParams(query)
  return urlParams.get('partner')
}
